import { Container } from '@seek/ai-elements';
import { useTranslations } from '@vocab/react';
import { Box, Stack, Divider } from 'braid-design-system';
import { useCallback } from 'react';

import translations from '../.vocab';
import { CareerFeedAIHeading } from '../CareerFeedAIHeading';
import { CareerFeedMobileWebFeatureFlagContainer } from '../CareerFeedMobileWebFeatureFlagContainer';
import RefreshRecommendationsButton from '../RefreshRecommendationsButton';
import { useGetResetCandidateChatContext } from '../hooks/candidateChatContextHelpers';
import { useCareerFeedAIAssistant } from '../hooks/useCareerFeedAIAssistant';

import { CareerFeedAIAssistantContentFrame } from './CareerFeedAIAssistantContentFrame';
import { TextSection } from './TextSection';

export const RecommendationRefinedConfirmation = () => {
  const resetPreferences = useGetResetCandidateChatContext();
  const {
    tracking: { trackGenAIChatResetPressed },
  } = useCareerFeedAIAssistant();
  const { t } = useTranslations(translations);

  const onReset = useCallback(() => {
    trackGenAIChatResetPressed('chat widget');
    resetPreferences();
  }, [resetPreferences, trackGenAIChatResetPressed]);

  return (
    <CareerFeedMobileWebFeatureFlagContainer
      mobileView={
        <Container borderWidth="standard">
          <Box>
            <Stack space="medium">
              <CareerFeedAIHeading headingText={t('Refined for you')} />

              <TextSection>
                {t(
                  "We've updated your recommendations based on your answers. Take a look at the personalised job listings.",
                )}
              </TextSection>
              <Divider />
              <RefreshRecommendationsButton onReset={onReset} />
            </Stack>
          </Box>
        </Container>
      }
      tabletAndAboveView={
        <CareerFeedAIAssistantContentFrame
          containerHeadMessage={t(
            "We've updated your recommendations based on your answers. Take a look at the personalised job listings.",
          )}
          containerCtaSection={
            <RefreshRecommendationsButton onReset={onReset} />
          }
          containerContentSection={<></>}
          loadingOnDrawer={
            false /* Loading is just used for loading overlay, we don't want this on the final q */
          }
          loadingOnContainer={false}
        />
      }
    />
  );
};
